'use strict';

app.config(function ($popupProvider) {

  $popupProvider.define('terms', function () {
    return /*@ngInject*/ {
      windowClass: 'terms-modal',
      templateUrl: '/app/states/auth/terms.html'
    };
  });

  $popupProvider.define('auth', function (params) {
    return /*@ngInject*/ {
      windowClass: 'auth-modal',
      templateUrl: '/app/states/auth/auth.html',
      controller: function ($scope, $location, $social, $log, $rootScope, $http, Api, rmAnalytics) {

        $scope.credentials = {};

        $scope.view = params.view || 'login';
        if ($scope.view === 'signup-social') {
          rmAnalytics.track('signup');
        }
        $scope.go = function (view) {
          $scope.success = null;
          $scope.error = null;
          $scope.view = view;
        };

        $scope.facebook = function () {
          $social.authenticate('facebook')
            .then($scope.$dismiss)
            .then(Api.refresh)
            .catch(function () {
              $log.warn('failed to signup via facebook', arguments);
            });
        };

        $scope.google = function () {
          $social.authenticate('google')
            .then($scope.$dismiss)
            .then(Api.refresh)
            .catch(function () {
              $log.warn('failed to signup via google', arguments);
            });
        };

        $scope.linkedin = function () {
          $social.authenticate('linkedin')
            .then($scope.$dismiss)
            .then(Api.refresh)
            .catch(function () {
              $log.warn('failed to signup via linkedin', arguments);
            });
        };

        $scope.signupUser = function (credentials) {
          var self = this;
          $http.post('/api/v1/users?instanceId=' + $rootScope.instance._id, credentials)
            .then(function () {
              return Api.login(credentials);
            })
            .then($scope.$dismiss)
            .catch(function () {
              self.signupForm.email.$setValidity('emailAlreadyUsed', false);
              var $unwatch = self.$watch('credentials.email', function (n, o) {
                if (n != o) {
                  self.signupForm.email.$setValidity('emailAlreadyUsed', true);
                  $unwatch();
                }
              });
            });
        };

        $scope.login = function () {
          $scope.error = '';
          Api.login($scope.credentials)
            .then($scope.$dismiss)
            .catch(function () {
              $scope.error = 'The Email Address or Password is incorrect. <br/> Please try again.';
            });
        };

        $scope.forgotPassword = function () {
          $scope.success = null;
          var data = {
            email: $scope.credentials.email
          };
          return $http.post('/api/v1/auth/forgot?instanceId=' + $rootScope.instance._id, data)
            .then(function () {
              $scope.success = true;
            })
            .catch(function () {
              $scope.success = false;
            });
        };

        $scope.resetPassword = function () {
          var data = {
            token: params.token,
            password: $scope.credentials.password
          };
          return $http.post('/api/v1/auth/reset', data)
            .then(function () {
              $scope.$dismiss();
              $scope.success = true;
              Api.refresh();
            })
            .catch(function () {
              $scope.success = false;
            });
        };

      }
    };
  });

});
